import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { IBusinessInfo } from "../interface/IBusiness";
import BusinessService from "../service/BusinessService";
import { RootState } from "../store/store";
import { logoutUser } from "./common";


export const resetBusiness = createAction("business/reset")

const _service = new BusinessService();

type SliceState = { value: IBusinessInfo, status: string,apiCallCount:number }

const initialState = {
  value: {},
  status: COMMON_STATUS.INITIAL,
  apiCallCount:0
} as SliceState;

export const getBusinessAsync = createAsyncThunk(
  "business/getBusiness",
  async (params: any) => {
    const response = await _service.getBusinessService(params);
    return response;
  }
);


export const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    setBusinessStatus: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBusinessAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getBusinessAsync.fulfilled, (state, action) => {
        // const dtJs = convertFormatFromApiToJs(action.payload.dateFormat);
        // action.payload.dateJs = dtJs;

        // const dtMoment = convertFormatFromApiToMoment(action.payload.dateFormat);
        // action.payload.dtMoment = dtMoment;

        state.value = action.payload;
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getBusinessAsync.rejected, (state) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetBusiness, () => {
        return initialState;
      });
  },
});

export const { setBusinessStatus } = businessSlice.actions;
export const getBusiness = (state: RootState) => state.business;
export const getBusinessInfo = (state: RootState) => state.business.value;
export const getBusinessStatus = (state: RootState) => state.business.status;

export default businessSlice.reducer;